module.exports = __webpack_public_path__ + "img/logo.66df7649.png";